module.exports = __webpack_public_path__ + "static/case-3-be7aa719901271a241af942ace88543e.jpg";